<template>
  <div class="hello">
    <h4>Reset Password</h4>
    <el-alert v-if='message.value'
    :title="message.value"
    :type="message.type">
  </el-alert>
    <el-form ref="form">
    
      <el-form-item label="Email">
        <el-input  :disabled="true" v-model="user.email" v-validate="{required:true}" autocomplete="off" name="email"></el-input>
       
      </el-form-item>

      <el-form-item label="Password">
        <el-input
          v-model="user.password"
          autocomplete="off"
          type="text"
          @keyup.enter.native="authenticate()"
        ></el-input>
      </el-form-item>

      <el-form-item label="Confirm your Password">
        <el-input
          v-model="user.confirmPassword"
          autocomplete="off"
          type="password"
          @keyup.enter.native="resetPassword()"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" style="float:right" @click="resetPassword">Reset Password</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import api from "@/api";
export default {
  name: "HelloWorld",
  data() {
    return {
      user:{
          token:''
      },
      message:{
          value:'',
          type:'success'
      }
    };
  },
  methods:{
    async resetPassword(){
        try{
            await api.resetPassword(this.user);
            this.message.value = 'Your Password has been reset,Please login with new password';
            this.message.type = 'success'
        }catch(e){
             this.message.value = 'Something went wrong,Please try again';
            this.message.type = 'error'
        }
        
    }
  },
  created(){
      console.log('query',this.$route.query)
      this.user.token = this.$route.query.token;
      this.user.email = this.$route.query.email;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue